import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import mockData from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="mb-4">
              <h3 className="text-2xl font-bold brand-font">AutoRust Pro</h3>
              <p className="text-xs text-gray-400">Rust Repair & Undercoating</p>
            </div>
            <p className="text-gray-400 text-sm">
              Professional automotive rust repair and truck undercoating services. Protecting your investment, one vehicle at a time.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-amber-500 transition-colors duration-200">Home</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-amber-500 transition-colors duration-200">Services</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-amber-500 transition-colors duration-200">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Rust Repair</li>
              <li className="text-gray-400">Truck Undercoating</li>
              <li className="text-gray-400">Vehicle Protection</li>
              <li className="text-gray-400">Preventive Treatment</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{mockData.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{mockData.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{mockData.contact.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{mockData.contact.hours}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} AutoRust Pro. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;